import { fetchApi } from "./index";

export enum OnboardingMessageType {
  TEXT = "text",
  FILE = "file",
}

export enum MessageContext {
  ONLINE = "online",
  OFFLINE = "offline",
}

export interface OnboardingMessage {
  id: string;
  message: string;
  type: OnboardingMessageType;
  message_context?: MessageContext;
  metadata: Record<string, any>;
  created_at: string;
  updated_at: string;
  position: number;
}

export const getOnboardingMessages = async (
  userId: string,
  context?: MessageContext,
) => {
  const { data } = await fetchApi<OnboardingMessage[]>({
    url: `/v2/onboarding-messages/user/${userId}`,
    params: {
      context,
    },
    method: "GET",
  });
  return data;
};

export const createOnboardingMessage = async (
  userId: string,
  message: string,
  metadata: Record<string, any> = {},
  messageContext: MessageContext = MessageContext.ONLINE,
) => {
  const { data } = await fetchApi<OnboardingMessage>({
    url: `/v2/onboarding-messages/user/${userId}`,
    method: "POST",
    data: {
      message,
      type: OnboardingMessageType.TEXT,
      metadata,
      message_context: messageContext,
    },
  });
  return data;
};

export const createOnboardingVideoMessage = async (
  userId: string,
  file: File,
  metadata: Record<string, any> = {},
  messageContext: MessageContext = MessageContext.ONLINE,
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("metadata", JSON.stringify(metadata));
  formData.append("message_context", messageContext);

  const { data } = await fetchApi<OnboardingMessage>({
    url: `/v2/onboarding-messages/user/${userId}/file`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

export const updateOnboardingMessage = async (
  messageId: string,
  message: string,
  metadata: Record<string, any> = {},
  messageContext?: MessageContext,
) => {
  const dataPayload: any = {
    message,
    metadata,
  };

  if (messageContext !== undefined) {
    dataPayload.message_context = messageContext;
  }

  const { data } = await fetchApi<OnboardingMessage>({
    url: `/v2/onboarding-messages/${messageId}`,
    method: "PUT",
    data: dataPayload,
  });
  return data;
};

export const deleteOnboardingMessage = async (messageId: string) => {
  await fetchApi({
    url: `/v2/onboarding-messages/${messageId}`,
    method: "DELETE",
  });
};

export const reorderOnboardingMessages = async (
  userId: string,
  messageIds: string[],
  messageContext?: MessageContext,
) => {
  const dataPayload: any = {
    messageIds,
  };
  if (messageContext !== undefined) {
    dataPayload.message_context = messageContext;
  }

  const { data } = await fetchApi<OnboardingMessage[]>({
    url: `/v2/onboarding-messages/user/${userId}/reorder`,
    method: "POST",
    data: dataPayload,
  });
  return data;
};
